import { serviceLogin } from ".";

export default {
  login: (data) => serviceLogin.post("/users/auth", data),
};
